import { useQuery } from '@apollo/client'
import type { DateTime } from 'luxon'
import { useState } from 'react'

import logger from '@/utils/logger'

import { useIsPageVisible } from '@/client/hooks'
import { ONLINE_USERS_QUERY } from '@/client/services/hasura'
import type {
  OnlineUsersQuery,
  OnlineUsersQueryVariables,
} from '@/client/services/hasura/generated/graphql'

import { onlineUserBaseFromFragment } from '../../transforms/detailsFromFragments'
import type { OnlineUserBase } from '../../types'

const QUERY_REFRESH_SECONDS = 60

export default function useOnlineUsers(): {
  onlineUsers: { id: number; lastOnlineAt: DateTime }[]
  loading: boolean
} {
  const isPageVisible = useIsPageVisible()

  const [onlineUsers, setOnlineUsers] = useState<OnlineUserBase[]>([])

  const { loading } = useQuery<OnlineUsersQuery, OnlineUsersQueryVariables>(ONLINE_USERS_QUERY, {
    skip: !isPageVisible,
    onCompleted: data => {
      const newOnlineUsers = (data?.user_online ?? []).map(onlineUserBaseFromFragment)

      setOnlineUsers(newOnlineUsers)
    },
    onError: error => {
      logger.warning('Error fetching online users', { error })
    },
    pollInterval: QUERY_REFRESH_SECONDS * 1000,
  })

  return { onlineUsers, loading }
}
